module.exports = __webpack_public_path__ + "components/flag/static/square/sc-1ca160935f1db6209298ed936acaf19e.svg";